export default __webpack_public_path__ + "static/media/pca-logo.0389f52e.svg";